import { render } from "./SwiperSlider.vue?vue&type=template&id=79833fd5&scoped=true"
import script from "./SwiperSlider.vue?vue&type=script&lang=js"
export * from "./SwiperSlider.vue?vue&type=script&lang=js"

import "./SwiperSlider.vue?vue&type=style&index=0&id=79833fd5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79833fd5"]])

export default __exports__